/**
 * Transaction process graph for practitioner onboarding emails:
 *   - soulwise-practitioner-onboarding
 */

export const transitions = {
  START_ONBOARDING: 'transition/start-onboarding',
  UPDATE_CHECKLIST: 'transition/update-checklist',
  COMPLETE_ONBOARDING: 'transition/complete-onboarding',
  EXPIRE_ONBOARDING: 'transition/expire-onboarding',
};

export const states = {
  INITIAL: 'initial',
  ONBOARDING: 'onboarding',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
};

export const graph = {
  id: 'soulwise-practitioner-onboarding/release-1',
  initial: states.INITIAL,
  states: {
    [states.INITIAL]: {
      on: {
        [transitions.START_ONBOARDING]: states.ONBOARDING,
      },
    },
    [states.ONBOARDING]: {
      on: {
        [transitions.UPDATE_CHECKLIST]: states.ONBOARDING,
        [transitions.COMPLETE_ONBOARDING]: states.COMPLETED,
        [transitions.EXPIRE_ONBOARDING]: states.EXPIRED,
      },
    },
    [states.COMPLETED]: { type: 'final' },
    [states.EXPIRED]: { type: 'final' },
  },
};

export const isRelevantPastTransition = () => false;
export const isCustomerReview = () => false;
export const isProviderReview = () => false;
export const isPrivileged = () => false;
export const isCompleted = transition => transition === transitions.COMPLETE_ONBOARDING;
export const isRefunded = () => false;
export const statesNeedingProviderAttention = [];
